import React from "react";

const AdditionalInformationRow = (props) => {
    return (<>
        <tr className="utility-row additional-host-row">
            <td style={{verticalAlign: 'top'}}>
                {(props.label) && (
                    <div className="sub-table-field"
                        dangerouslySetInnerHTML={{__html: `${props.label}:`}}
                    ></div>
                )}
            </td>
            <td colSpan={2} style={{verticalAlign: 'top'}}>
                <div className="sub-table-content icon-indented">
                    <span>
                        { props.content }
                        { (props.suffix) && (
                            <small className="suffix">
                                {props.suffix}
                            </small>
                        )}
                    </span>
                </div>
            </td>
            <td>
                { props.additionalContent && (
                    <div className="sub-table-content">
                        { props.additionalContent }
                    </div>
                )}
            </td>
            <td colSpan={4} className="hide-for-small-only"></td>
        </tr>
    </>);
}

export default AdditionalInformationRow;
